import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { mobile, mobileM, tablet, laptop, laptopM } from "../../responsive";
import { IconButton, Badge } from "@material-ui/core";
// icons
import { ShoppingCartOutlined } from "@material-ui/icons";
import { Link, useLocation } from "react-router-dom";

//

import useStyles from "./styles";
// import logo from "../../assets/commerce.png";
//
import DragCompMain from "./DraggableMain";
//
//
const Header = styled.div`
  transition: all 0.6s ease-in-out;
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
`;
const Navigation = styled.div`
  padding: 30px 0 30px 0;
  width: 95%;
  min-height: 8vh;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  flex-grow: 1;
  //
  position: fixed;
  top: 0;
  z-index: 3;
  //
  //background-color: red;
  transition: color 0.6s ease-in-out;
  //
  //

  .white {
    // *** flex
    display: flex;
    flex-grow: 1;
    align-items: center;
    margin: 10px 0 0 20px;
    // *** Font
    color: #121212; //
    font-family: "Syncopate-Bold";
    letter-spacing: 5px;
    font-size: 1.7em;
    font-weight: 600;
    // *** BOX SHADOW
    text-decoration: none;
    box-shadow: -16px 17px 0px -4px #00ffb3;

    //
    //
    //
    // *** MEDIA QUERIE
    ${mobile({
      padding: "8px 30px",
      fontSize: `calc(19px + 1.1vmin)`,
    })}
    ${mobileM({
      padding: "8px 30px",
      fontSize: `calc(19px + 1.1vmin)`,
    })}
  ${tablet({
      fontSize: `calc(22px + 1.1vmin)`,
    })}
  ${laptop({
      fontSize: `calc(24px + 1.1vmin)`,
    })}
  ${laptopM({
      fontSize: `calc(28px + 1.1vmin)`,
    })}

    //
    //
  }
  .black {
    // *** this one comes after the "white" when scrolling
    margin: 10px 0 0 20px;
    padding: 26px 32px;
    //
    color: #fff;
    background: #121212;
    //
    border: 3px solid #fff;
    border-radius: 111px 111px 111px 111px;
    box-shadow: -13px -13px 0px -4px rgba(0, 0, 0, 0.75);

    //
    font-family: "Syncopate-Bold";
    letter-spacing: 8px;
    font-size: 1.7em;
    font-weight: 600;
    text-decoration: none;
    // #ff0080; //tomato

    //
    // *** MEDIA QUERIE
    ${mobile({
      padding: "8px 30px",
      fontSize: `calc(12px + 1.1vmin)`,
    })}
    ${mobileM({
      padding: "8px 30px",
      fontSize: `calc(12px + 1.1vmin)`,
    })}
  ${tablet({
      fontSize: `calc(18px + 1.1vmin)`,
    })}
  ${laptop({
      fontSize: `calc(9px + 1.1vmin)`,
    })}
  }

  /* .scroll {
    transition: all 0.6s ease-in-out;
    background-color: #ffffff;
  } */
`;
const TitleLogo = styled.div`
  // **** DEFAULT LOGO
  // this set up is when you are
  // redirected to the basket component
  // the ones above (.black & .white)
  // are the settings when scrolling

  // *** this default comes first, before the '.white'
  //
  margin: 10px 0 0 20px;
  padding: 20px 35px;
  display: flex;
  flex-grow: 1;
  align-items: center;
  //
  border: 2px solid #121212;
  border-radius: 193px 193px 193px 193px;
  // *** FONT default

  color: #121212;
  font-family: "Syncopate-Bold";
  letter-spacing: 5px;
  font-size: calc(15px + 1.1vmin);
  font-weight: 600;
  box-shadow: 16px -15px 0px 0px rgba(0, 0, 0, 0.75);
  //
  transition: all 0.6s ease-in-out;

  // *** Hover LOGO
  &:hover {
    border: 2px solid #121212;
    background-color: #fbfbfb;
    color: #121212;
  }
  //
  //
  // *** MEDIA QUERIE
  ${mobile({
    margin: "5px 0 0 5px",
    padding: "8px 30px",
    fontSize: `calc(9px + 1.1vmin)`,
  })}
  ${mobileM({
    margin: "5px 0 0 5px",
    padding: "8px 30px",
    fontSize: `calc(9px + 1.1vmin)`,
  })}
  ${tablet({
    // color: "red",
    margin: "5px 0 0 5px",
    padding: "8px 30px",
    fontSize: `calc(18px + 1.1vmin)`,
  })}
  ${laptop({
    margin: "5px 0 0 5px",
    padding: "8px 30px",
    fontSize: `calc(9px + 1.1vmin)`,
  })}


  //
  //-----------------
  // *** Gradient (smoke effect of the navbar)
  //
  &:after {
    content: "";
    z-index: -1;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
    //
    // *** the gradient colors
    background: linear-gradient(-45deg, #fffbcf -12%, #cfffe7 144%);
    transform: translate3d(-2px, 20px, 0) scale(2.07);
    // *** the gradient BLUR
    filter: blur(60px); //original 20px
    opacity: var(0.6);
    transition: opacity 0.3s;
    border-radius: inherit;
  }
  // *** MEDIA
  ${mobile({})}
  ${mobileM({})}
  ${tablet({})}
  ${laptop({})}
`;
//
//
//
//

const Navbar = ({ totalItems }) => {
  const classes = useStyles();
  const location = useLocation();
  //
  //
  //
  //
  const [navbar, setNavbar] = useState(false);
  const [color, setColor] = useState(false);

  //
  //
  //CHANGE FONT ON SCROLL---------------------
  const changeFontOnScroll = () => {
    if (window.scrollY >= 700) {
      setNavbar(true);
      setColor("black");
    } else {
      setNavbar(false);
      setColor("white");
    }
  };
  //
  useEffect(() => {
    window.addEventListener("scroll", changeFontOnScroll, true);
    return () => window.removeEventListener("scroll", changeFontOnScroll);
  }, []);
  //
  //
  //  SHOW ARROW 'BACK TO TOP' ON SCROLL---------------------
  //
  return (
    <>
      <Header
        className={navbar ? "scroll" : "navbar"}
        // style={{
        //   backgroundColor: "white",
        // }}
      >
        <Navigation>
          <Link to="/">
            <TitleLogo className={color}>NEMU</TitleLogo>
          </Link>
          {/* <Typography component={Link} to="/" variant="h6">fluxus </Typography> */}
          {/* {" className={color}"} */}

          {location.pathname === "/" && (
            <div>
              <IconButton
                className={classes.IconCartNavBar}
                component={Link}
                to="/cart"
                aria-label="Show cart items"
              >
                <Badge
                  overlap="rectangular"
                  badgeContent={totalItems}
                  color="secondary"
                  classes={{ badge: classes.customBadge }}
                  // colorBlu={colorBlu}
                >
                  {/* ShoppingCartOutlined  is the icon */}
                  <ShoppingCartOutlined
                    style={{
                      width: `calc(8px + 2vmin)`,
                      height: `calc(8px + 2vmin)`,
                    }}
                  />
                </Badge>
              </IconButton>
            </div>
          )}

          {/* 
        
        
        -------- DRAGGABLE   -------
        
         */}
          {location.pathname === "/checkout" && <DragCompMain />}
        </Navigation>
      </Header>
    </>
  );
};
export default Navbar;
